/* ICR redesign — shared behaviour (Kida Digital, Oct 2026) */
(function () {
  if (window.ICR) return;
  window.ICR = {};

  // One-tap add from product cards: uses the theme cart drawer
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-icr-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.icr-add');
    if (!btn || btn.disabled) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('cart-drawer');
    var fd = new FormData(form);
    if (drawer && drawer.getSectionsToRender) {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          var msg = form.parentElement.querySelector('.icr-card__err');
          if (!msg) { msg = document.createElement('p'); msg.className = 'icr-card__err'; msg.setAttribute('role', 'alert'); form.parentElement.appendChild(msg); }
          msg.textContent = res.description || res.message || 'Sorry, that couldn’t be added.';
          return;
        }
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
        if (window.publish && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'icr-card', productVariantId: fd.get('id') });
        }
        document.dispatchEvent(new CustomEvent('icr:cart-added', { detail: { variantId: fd.get('id'), source: form.dataset.icrSource || 'card' } }));
        if (drawer && drawer.renderContents) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) { console.error(err); })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  });

  // Size pills on product cards: update price + button for the chosen variant
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-icr-variant]');
    if (!input && e.target.matches && e.target.matches('[data-icr-variant-select]')) input = e.target.options[e.target.selectedIndex];
    if (!input) return;
    var card = input.closest('.icr-card');
    var price = card && card.querySelector('[data-icr-price]');
    if (price) {
      var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
      price.innerHTML = input.dataset.compare
        ? '<span class="is-sale">' + esc(input.dataset.price) + '</span> <s>' + esc(input.dataset.compare) + '</s>'
        : esc(input.dataset.price);
    }
    var btn = card && card.querySelector('.icr-add');
    if (btn) btn.disabled = input.dataset.available !== 'true';
  });

  // Card size pills: if they wrap past two rows, swap them for a dropdown so cards in a row stay level
  function pillsToSelect(set) {
    var pills = set.querySelectorAll('.icr-pills__pill');
    if (!pills.length || !set.offsetParent) return;
    var rows = {};
    Array.prototype.forEach.call(pills, function (p) { rows[p.offsetTop] = true; });
    set.dataset.icrChecked = '1';
    if (Object.keys(rows).length <= 2) return;
    var legend = set.querySelector('legend');
    var label = document.createElement('label');
    label.className = 'icr-vsel';
    var sr = document.createElement('span');
    sr.className = 'icr-vh';
    sr.textContent = legend ? legend.textContent : 'Option';
    var sel = document.createElement('select');
    sel.name = 'id';
    sel.className = 'icr-vsel__select';
    sel.setAttribute('data-icr-variant-select', '');
    Array.prototype.forEach.call(set.querySelectorAll('input[data-icr-variant]'), function (inp) {
      var o = document.createElement('option');
      o.value = inp.value;
      var text = inp.parentNode.querySelector('span');
      o.textContent = (text ? text.textContent : inp.value) + (inp.dataset.available === 'true' ? '' : ' (sold out)');
      o.dataset.price = inp.dataset.price;
      o.dataset.compare = inp.dataset.compare || '';
      o.dataset.available = inp.dataset.available;
      if (inp.dataset.available !== 'true') o.disabled = true;
      if (inp.checked) o.selected = true;
      sel.appendChild(o);
    });
    label.appendChild(sr);
    label.appendChild(sel);
    set.parentNode.replaceChild(label, set);
  }
  function checkPills() {
    Array.prototype.forEach.call(document.querySelectorAll('.icr-pills:not([data-icr-checked])'), pillsToSelect);
  }
  var pillTimer;
  function queuePills() { clearTimeout(pillTimer); pillTimer = setTimeout(checkPills, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queuePills); else queuePills();
  window.addEventListener('load', queuePills);
  window.addEventListener('resize', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.icr-pills[data-icr-checked]'), function (s) { s.removeAttribute('data-icr-checked'); });
    queuePills();
  });
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) { if (list[i].addedNodes.length) { queuePills(); return; } }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Card swatches: preview the connected product's image on hover
  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest && e.target.closest('[data-icr-sw-img]');
    if (!dot) return;
    var img = dot.closest('.icr-card') && dot.closest('.icr-card').querySelector('.icr-card__media img');
    if (!img) return;
    if (!img.dataset.icrSrc) { img.dataset.icrSrc = img.src; img.dataset.icrSrcset = img.srcset || ''; }
    img.removeAttribute('srcset');
    img.src = dot.dataset.icrSwImg;
    prefetch(dot.href);
  });
  // Globo setting "Preload linked product pages on hover": warm the connected product's page
  var prefetched = {};
  function prefetch(href) {
    if (!href || prefetched[href]) return;
    prefetched[href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    document.head.appendChild(l);
  }
  document.addEventListener('touchstart', function (e) {
    var dot = e.target.closest && e.target.closest('.icr-card__dot');
    if (dot) prefetch(dot.href);
  }, { passive: true });
  document.addEventListener('mouseout', function (e) {
    var row = e.target.closest && e.target.closest('.icr-card__sw');
    if (!row || (e.relatedTarget && row.contains(e.relatedTarget))) return;
    var img = row.closest('.icr-card').querySelector('.icr-card__media img');
    if (img && img.dataset.icrSrc) {
      img.src = img.dataset.icrSrc;
      if (img.dataset.icrSrcset) img.srcset = img.dataset.icrSrcset;
    }
  });

  // Remember the collection the shopper is browsing (product page breadcrumb follows their path)
  function rememberCollection() {
    var m = window.location.pathname.match(/^\/collections\/([^\/]+)\/?$/);
    if (!m) return;
    var h1 = document.querySelector('main h1, h1');
    var title = (h1 && h1.textContent.trim()) || document.title.split(/\s[|–-]\s/)[0].trim();
    try {
      window.sessionStorage.setItem('icr:lastCollection', JSON.stringify({ handle: decodeURIComponent(m[1]).toLowerCase(), title: title, url: '/collections/' + m[1] }));
    } catch (err) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rememberCollection); else rememberCollection();

  // Tabs (product tabs section)
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-icr-tab]');
    if (!tab) return;
    var root = tab.closest('[data-icr-tabs]');
    root.querySelectorAll('[data-icr-tab]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
      var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
      var more = root.querySelector('[data-icr-more="' + t.getAttribute('aria-controls') + '"]');
      if (more) more.hidden = !on;
    });
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-icr-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[data-icr-tab]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = tabs[(i + tabs.length) % tabs.length];
    next.focus(); next.click();
  });

  // Announcement bar: rotate on mobile only, pause for reduced motion
  function rotate() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-icr-ann]').forEach(function (bar) {
      var items = bar.querySelectorAll('.icr-ann__item');
      if (items.length < 2 || reduce) return;
      var i = 0;
      setInterval(function () {
        if (window.innerWidth > 749) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rotate); else rotate();
  // Header: mobile drawer, mega menu toggles, sticky shadow
  function setupHeader() {
    var drawer = document.querySelector('[data-icr-drawer]');
    var opener = document.querySelector('[data-icr-drawer-open]');
    if (drawer && opener) {
      var close = function () {
        drawer.hidden = true; opener.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = ''; opener.focus();
      };
      opener.addEventListener('click', function () {
        drawer.hidden = false; opener.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        var first = drawer.querySelector('button, a, summary'); if (first) first.focus();
      });
      drawer.querySelectorAll('[data-icr-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
      drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
    document.querySelectorAll('[data-icr-mega]').forEach(function (item) {
      var btn = item.querySelector('.icr-nav__toggle');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        document.querySelectorAll('[data-icr-mega].is-open').forEach(function (o) { o.classList.remove('is-open'); o.querySelector('.icr-nav__toggle').setAttribute('aria-expanded', 'false'); });
        item.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open);
      });
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); btn.focus(); } });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); } });
    });
    var header = document.querySelector('[data-icr-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupHeader); else setupHeader();
})();